import { motion } from "framer-motion";

const COACH_PHOTO =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_pronunciation-beta/artifacts/c8jv8ts7_755693814_10164667071137692_3189102994157477155_n.jpg";

export const MeetCoach = () => {
  return (
    <section
      data-testid="meet-coach-section"
      className="relative w-full px-4 py-20 sm:px-8 sm:py-24"
    >
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="mx-auto flex max-w-2xl flex-col items-center rounded-[32px] border border-slate-200/70 bg-white/80 p-10 text-center shadow-[0_25px_60px_-20px_rgba(2,132,199,0.15)] backdrop-blur-sm sm:p-14"
      >
        <span className="font-mono-accent text-xs font-semibold uppercase tracking-[0.25em] text-sky-600">
          Meet Your Coach
        </span>
        <img
          src={COACH_PHOTO}
          alt="Coach Drew Sisera"
          data-testid="coach-photo"
          className="mt-6 h-24 w-24 rounded-full object-cover shadow-[0_15px_35px_-10px_rgba(15,23,42,0.3)] ring-4 ring-white sm:h-28 sm:w-28"
        />
        <h3 className="font-display mt-5 text-xl font-bold text-slate-900 sm:text-2xl">
          Drew Sisera
        </h3>
        <p className="font-body mt-3 max-w-md text-base leading-relaxed text-slate-500 sm:text-lg">
          Hi, I’m Drew. I’ve helped thousands of learners bridge the fluency gap
          through the Sound Ladder method. I’m building this app to give that same
          power to every teacher and student.
        </p>
      </motion.div>
    </section>
  );
};
